module.exports = __webpack_public_path__ + "static/logo-blue-camion-cbff16a45b988afaf124c1d2bf302cdf.png";